import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Marketday } from './marketday.model';
import { DateUtils } from 'ng-jhipster';
@Injectable()
export class MarketdayService {

    private resourceUrl = 'api/marketdays';
    private resourceSearchUrl = 'api/_search/marketdays';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(marketday: Marketday): Observable<Marketday> {
        const copy: Marketday = Object.assign({}, marketday);
        copy.startTime = this.dateUtils.toDate(marketday.startTime);
        copy.endTime = this.dateUtils.toDate(marketday.endTime);
        copy.buildingStartTime = this.dateUtils.toDate(marketday.buildingStartTime);
        copy.dismantlingEndTime = this.dateUtils.toDate(marketday.dismantlingEndTime);
        copy.startTimeWinter = this.dateUtils.toDate(marketday.startTimeWinter);
        copy.endTimeWinter = this.dateUtils.toDate(marketday.endTimeWinter);
        copy.buildingStartTimeWinter = this.dateUtils.toDate(marketday.buildingStartTimeWinter);
        copy.dismantlingEndTimeWinter = this.dateUtils.toDate(marketday.dismantlingEndTimeWinter);
        copy.updated = this.dateUtils.toDate(marketday.updated);
        copy.created = this.dateUtils.toDate(marketday.created);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(marketday: Marketday): Observable<Marketday> {
        const copy: Marketday = Object.assign({}, marketday);

        copy.startTime = this.dateUtils.toDate(marketday.startTime);

        copy.endTime = this.dateUtils.toDate(marketday.endTime);

        copy.buildingStartTime = this.dateUtils.toDate(marketday.buildingStartTime);

        copy.dismantlingEndTime = this.dateUtils.toDate(marketday.dismantlingEndTime);

        copy.startTimeWinter = this.dateUtils.toDate(marketday.startTimeWinter);

        copy.endTimeWinter = this.dateUtils.toDate(marketday.endTimeWinter);

        copy.buildingStartTimeWinter = this.dateUtils.toDate(marketday.buildingStartTimeWinter);

        copy.dismantlingEndTimeWinter = this.dateUtils.toDate(marketday.dismantlingEndTimeWinter);

        copy.updated = this.dateUtils.toDate(marketday.updated);

        copy.created = this.dateUtils.toDate(marketday.created);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Marketday> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            const jsonResponse = res.json();
            jsonResponse.startTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.startTime);
            jsonResponse.endTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.endTime);
            jsonResponse.buildingStartTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.buildingStartTime);
            jsonResponse.dismantlingEndTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dismantlingEndTime);
            jsonResponse.startTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.startTimeWinter);
            jsonResponse.endTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.endTimeWinter);
            jsonResponse.buildingStartTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.buildingStartTimeWinter);
            jsonResponse.dismantlingEndTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.dismantlingEndTimeWinter);
            jsonResponse.updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    search(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }


    private convertResponse(res: any): any {
        const jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].startTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].startTime);
            jsonResponse[i].endTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].endTime);
            jsonResponse[i].buildingStartTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].buildingStartTime);
            jsonResponse[i].dismantlingEndTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dismantlingEndTime);
            jsonResponse[i].startTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].startTimeWinter);
            jsonResponse[i].endTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].endTimeWinter);
            jsonResponse[i].buildingStartTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].buildingStartTimeWinter);
            jsonResponse[i].dismantlingEndTimeWinter = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].dismantlingEndTimeWinter);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        const options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            const params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketday/marketday.service.ts